import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { translate } from "react-i18next";
import { MenuItem } from "@material-ui/core";
import socialType from "../../utils/socialType";
import { styles } from "./styles";
import InputFormat from "../inputForm";
class FromType extends Component {
  render() {
    const {
      t,
      className,
      label,
      value,
      margin = "dense",
      SelectProps = {},
      name,
      disabled = false,
      onChange,
      InputProps = {},
      InputLabelProps = {},
    } = this.props;

    return (
      <InputFormat
        select
        disabled={disabled}
        name={name}
        label={label}
        margin={margin}
        value={value}
        onChange={onChange}
        fullWidth
        SelectProps={{
          displayEmpty: true,
          ...SelectProps,
        }}
        className={className}
        InputProps={InputProps}
        InputLabelProps={InputLabelProps}
      >
        <MenuItem>{t("pls_select")}</MenuItem>
        <MenuItem key="website" value="website">
          {"Website"}
        </MenuItem>
        {socialType.map((type, index) => (
          <MenuItem key={index} value={type.value}>
            {t(type.name)}
          </MenuItem>
        ))}
      </InputFormat>
    );
  }
}

FromType.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default translate("translations")(
  withStyles(styles, { withTheme: true })(FromType)
);
